import { Alert, Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { useIntl } from 'react-intl';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import {
  RecipientInvoiceFormValues,
  RecipientInvoiceSituation,
} from '@/core/domain/invoice/recipientInvoice/recipientInvoice.types';
import { useDefaultEmptyFieldError } from '@/hooks';

type Props = {
  form: FormInstance<RecipientInvoiceFormValues>;
};

const ManifestationRecipientForm = ({ form }: Props) => {
  const intl = useIntl();
  const companyId = Form.useWatch('companyId', form);

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const recipientInvoiceOptions = [
    { value: RecipientInvoiceSituation.pending, label: 'Pendente' },
    {
      value: RecipientInvoiceSituation.confirmedOperation,
      label: 'Confirmação da operação',
    },
    { value: RecipientInvoiceSituation.confirmed, label: 'Ciência da Emissão' },
    {
      value: RecipientInvoiceSituation.unknown,
      label: 'Desconhecimento da Operação',
    },
    {
      value: RecipientInvoiceSituation.notExecuted,
      label: 'Operação não Realizada',
    },
  ];

  return (
    <>
      <Form form={form} style={{ marginBottom: '2em' }}>
        <Row gutter={[12, 5]}>
          {!companyId && (
            <Col span={24}>
              <Alert
                type="warning"
                message="Selecione uma empresa para trazer a listagem"
                style={{ marginBottom: 12 }}
              />
            </Col>
          )}

          <Col span={24} md={24} xl={8}>
            <FloatingFormItem
              name="companyId"
              label={intl.formatMessage({
                id: 'invoice.manifestationRecipient.form.company',
              })}
              rules={[defaultEmptyFieldError]}
            >
              <CompaniesInfiniteSelectField />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} xl={8}>
            <FloatingFormItem name="situation" label="Situação">
              <Select
                allowClear
                options={recipientInvoiceOptions.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} xl={8}>
            <FloatingFormItem name="nsu" label="NSU">
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} xl={8}>
            <FloatingFormItem name="nfeKey" label="Chave Nota">
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} xl={8}>
            <FloatingFormItem name="issuer" label="Fornecedor">
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ManifestationRecipientForm;
